import { ArticleImage, loadLargeImage } from '../articleImage';
import {
  accordionInit,
  contentListItemColor,
  initModalRevealsForArticle,
  initTwoClickIframes
} from '../../articleHelper';
import ArticlePresenter from '../../articlePresenter';
import BackElement from '../backElement';
import CallToAction from '../callToAction';
import FormRenderer from '../forms/formRenderer';
import VideoRenderer from '../videos/videoRenderer';
import WidgetRenderer from '../widgets/widgetRenderer';
import React from 'react';
import $ from 'jquery';

class ConsultantArticle extends React.Component {
  constructor() {
    super();
    this.state = {
      article: ArticlePresenter.nullArticle(),
      widgets: []
    };
  }

  componentDidMount() {
    this.ajaxArticle();
  }

  ajaxArticle() {
    const methods = [
      'title',
      'content',
      'context_info',
      'call_to_action',
      'image_links_mobil_oben_content',
      'image_alt_links_mobil_oben',
      'image_links_mobil_unten_content',
      'image_alt_links_mobil_unten',
      'image_rechts_mobil_oben_content',
      'image_alt_rechts_mobil_oben',
      'image_rechts_mobil_unten_content',
      'image_alt_rechts_mobil_unten',
      'image_focus_hintergrund_mini',
      'image_focus_hintergrund_teaser',
      'image_focus_hintergrund_background',
      'consultant.branch.location',
      'consultant.full_name',
      'consultant.languages',
      'consultant.qualifications',
      'consultant',
      'image_videovorschau_content',
      'image_alt_videovorschau',
      'vimeo_video',
      'youtube_video',
      'video_position',
      'widget_ids'
    ].join();

    $.ajax({
      url: `/api/v3/articles/${this.props.articleId}.json?methods=${methods}`,
      method: 'GET',
      success: (data) => {
        if (data !== undefined && data !== null) {
          this.setState({ article: ArticlePresenter.getArticle(data) }, function () {
            loadLargeImage(this);
            contentListItemColor();
            VideoRenderer.renderVideoModal(this.state.article.vimeoVideo);
            VideoRenderer.renderVideoModal(this.state.article.youtubeVideo);
            WidgetRenderer.widgetsForObject(this.state.article, (widgets) => {
              this.setState({ widgets }, () => {
                initModalRevealsForArticle(this.props.articleId);
                accordionInit();
                initTwoClickIframes();
              });
            });
          });
        }
      },
      error: (xhr, status, err) => console.error(this.props.articleId, status, err.toString())
    });
  }

  render() {
    return (
      <div className="background-fixed" style={this.state.article.imageBackground}>
        <div className="container">
          <div className="row">
            <aside className="sidebar">&nbsp;</aside>

            <article className="content">
              <div className="row">
                <BackElement />
              </div>

              <div className="row">
                <MainContent article={this.state.article} widgets={this.state.widgets} />
                <FurtherContent article={this.state.article} widgets={this.state.widgets} />
              </div>
            </article>

            <aside className="spacebar">&nbsp;</aside>
          </div>
        </div>
      </div>
    );
  }
}

ConsultantArticle.propTypes = {
  articleId: React.PropTypes.number
};

function MainContent({ article, widgets }) {
  function consultantFunction() {
    if (!article.consultant.function) {
      return null;
    }

    return (
      <span className="text-bold color-primary">
        {article.consultant.function}
        <br />
      </span>
    );
  }

  function consultantSlogan() {
    if (!article.consultant.slogan) {
      return null;
    }

    return (
      <span className="color-secondary">
        {article.consultant.slogan}
        <br />
      </span>
    );
  }

  function whofinanceWidget() {
    if (!article.consultant.whofinance) {
      return null;
    }

    const scriptSrc = `
      https://www.whofinance.de/wfwidget/berater/${article.consultant.whofinance}/QuirinSmallWidget.js
    `;

    return (
      <div>
        <div className="WhoFinance_Widget_container">
          <div id="WhoFinance_QuirinSmallWidget_container"></div>
        </div>
        <script
          src={scriptSrc}
          type="text/javascript"
          data-liquid="true"
          data-cookieconsent="ignore"
        ></script>
      </div>
    );
  }

  let vimeoVideo = null;
  let youtubeVideo = null;

  if (article.videoPosition === 'left') {
    // render videos under main content if the video position is set to 'left'
    vimeoVideo = VideoRenderer.renderVideoImage(
      article.vimeoVideo,
      article.imageVideoUrl,
      article.imageVideoAlt
    );
    youtubeVideo = VideoRenderer.renderVideoImage(
      article.youtubeVideo,
      article.imageVideoUrl,
      article.imageVideoAlt
    );
  }

  return (
    <div className="col-1-of-2 main-content content-lg">
      <h1 className="margin-bottom-xxs">{article.title}</h1>
      <p>
        {consultantFunction()}
        {consultantSlogan()}
      </p>
      <ArticleImage imageUrl={article.imageLeftTopUrl} imageAlt={article.imageLeftTopAlt} />
      <div className="hidden-mobile">
        <ArticleImage imageUrl={article.imageLeftBottomUrl} imageAlt={article.imageLeftBottomAlt} />
      </div>
      <div className="hidden-desktop">
        <ArticleImage imageUrl={article.imageRightTopUrl} imageAlt={article.imageRightTopAlt} />
      </div>
      {WidgetRenderer.renderWidgets(widgets, 'before-main-content')}
      <div dangerouslySetInnerHTML={{ __html: article.mainContent }}></div>
      <div dangerouslySetInnerHTML={{ __html: article.consultant.career }}></div>
      <Characteristics consultant={article.consultant} />
      <CallToAction
        callToActionText={article.callToActionText}
        callToActionLink={article.callToActionLink}
      />
      {whofinanceWidget()}
      {vimeoVideo}
      {youtubeVideo}
      {WidgetRenderer.renderWidgets(widgets, 'main-content-before-form')}
      {FormRenderer.displayFor(article, 'main_content')}
      {FormRenderer.formInModal(article, 'modal_main_content')}
      {WidgetRenderer.renderWidgets(widgets, 'main-content')}
      <div className="hidden-desktop">
        <ArticleImage imageUrl={article.imageLeftBottomUrl} imageAlt={article.imageLeftBottomAlt} />
      </div>
    </div>
  );
}

MainContent.propTypes = {
  article: React.PropTypes.object,
  widgets: React.PropTypes.array
};

function Characteristics({ consultant }) {
  const attributesAndLabels = [
          ['birthday', 'Jahrgang'],
          ['education', 'Ausbildung'],
          ['birthplace', 'Geburtsort'],
          ['languages', 'Sprachen'],
          ['qualifications', 'Qualifikationen'],
          ['hobby', 'Freizeit'],
          ['holiday_destination', 'Liebstes Reiseziel'],
          ['favorite_movie', 'Lieblingsfilm'],
          ['favorite_book', 'Lieblingsbuch'],
          ['favorite_place', 'Lieblingsort']
        ],
        characteristicsRows = attributesAndLabels
          .filter((element) => consultant[element[0]] && consultant[element[0]] !== '')
          .map((element, index) => (
            <tr key={index}>
              <td className="color-secondary">{element[1]}</td>
              <td>{consultant[element[0]]}</td>
            </tr>
          ));

  return (
    <div className={characteristicsRows.length ? 'characteristics-box' : ''}>
      <table>
        <tbody>{characteristicsRows}</tbody>
      </table>
    </div>
  );
}

Characteristics.propTypes = {
  consultant: React.PropTypes.object
};

function FurtherContent({ article, widgets }) {
  function consultantBranchLocation() {
    if (!article.consultant.branch.location) {
      return null;
    }

    return (
      <span>
        {article.consultant.branch.location.street}
        <br />
        {article.consultant.branch.location.zip} {article.consultant.branch.location.city}
      </span>
    );
  }

  function consultantPhone() {
    if (!article.consultant.phone) {
      return null;
    }

    return (
      <span>
        <span>T</span>&nbsp;
        <a
          className="link-unstyled"
          href={`tel:${article.consultant.phone}`}
          title="Berater anrufen"
        >
          {article.consultant.phone}
        </a>
        <br />
      </span>
    );
  }

  function consultantFax() {
    if (!article.consultant.fax) {
      return null;
    }

    return (
      <span>
        <span>F</span> {article.consultant.fax}
        <br />
      </span>
    );
  }

  function consultantEMail() {
    if (!article.consultant.email) {
      return null;
    }

    return (
      <span>
        <a
          href={`mailto:${article.consultant.email}`}
          title={`E-Mail an ${article.consultant.email}`}
          className="link-unstyled"
        >
          {article.consultant.email}
        </a>
        <br />
      </span>
    );
  }

  function consultantLinkedIn() {
    if (!article.consultant.linkedin) {
      return null;
    }

    return (
      <span>
        <a
          href={article.consultant.linkedin}
          title={`Zum LinkedIn-Profil: ${article.consultant.linkedin}`}
          className="link-unstyled"
          target="_blank"
        >
          Zum LinkedIn-Profil
        </a>
        <br />
      </span>
    );
  }

  let vimeoVideo = null;
  let youtubeVideo = null;

  if (article.videoPosition === 'right') {
    // render videos in further content if the selected video position is 'right'
    vimeoVideo = VideoRenderer.renderVideoImage(
      article.vimeoVideo,
      article.imageVideoUrl,
      article.imageVideoAlt
    );

    youtubeVideo = VideoRenderer.renderVideoImage(
      article.youtubeVideo,
      article.imageVideoUrl,
      article.imageVideoAlt
    );
  }

  return (
    <div className="col-1-of-2 further-content content-sm">
      <div className="hidden-mobile">
        <ArticleImage imageUrl={article.imageRightTopUrl} imageAlt={article.imageRightTopAlt} />
      </div>
      <div className="hidden-mobile">
        <ArticleImage
          imageUrl={article.imageRightBottomUrl}
          imageAlt={article.imageRightBottomAlt}
        />
      </div>
      <div dangerouslySetInnerHTML={{ __html: article.furtherContent }}></div>
      <div>
        <div>
          {WidgetRenderer.renderActionWidget('consultant', article)}
          <p className="color-secondary">
            Quirin Privatbank {article.consultant.department}
            <br />
            {article.consultant.fullName}
            <br />
            {consultantBranchLocation()}
          </p>
          <p className="color-secondary">
            {consultantPhone()}
            {consultantFax()}
            {consultantEMail()}
            {consultantLinkedIn()}
          </p>
        </div>
      </div>
      <div className="clearfix"></div>
      {vimeoVideo}
      {youtubeVideo}
      {WidgetRenderer.renderWidgets(widgets, 'further-content-before-form')}
      {FormRenderer.displayFor(article, 'further_content')}
      {FormRenderer.formInModal(article, 'modal')}
      {WidgetRenderer.renderWidgets(widgets, 'further-content')}
      <div className="hidden-desktop">
        <ArticleImage
          imageUrl={article.imageRightBottomUrl}
          imageAlt={article.imageRightBottomAlt}
        />
      </div>
    </div>
  );
}

FurtherContent.propTypes = {
  article: React.PropTypes.object,
  widgets: React.PropTypes.array
};

export default ConsultantArticle;



// WEBPACK FOOTER //
// ./components/articles/consultantArticle.js